var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOther(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 77,
    viewBox: "0 0 84 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M80 40.01C80 17.91 62.1 0 40.01 0C17.91 0 0 17.9 0 39.99C0 45.68 1.21 51.31 3.56 56.5H76.43C78.78 51.32 80 45.69 79.99 40L80 40.01Z",
    fill: "#E0E9FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 56.5098H78.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5 56.5098H83",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5904 20.1903C44.5904 26.4703 39.5004 31.5503 33.2204 31.5503C26.9404 31.5503 21.8604 26.4603 21.8604 20.1903V16.1803C21.8604 9.90031 26.9504 4.82031 33.2304 4.82031C39.5104 4.82031 44.5904 9.91031 44.5904 16.1803V20.1903Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5998 56.4998V51.3698C50.6698 41.7698 42.9498 33.9298 33.3498 33.8598C23.7498 33.7898 15.9098 41.5098 15.8398 51.1098C15.8398 51.1998 15.8398 51.2898 15.8398 51.3698V56.4998H50.5998Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5904 20.1903C44.5904 26.4703 39.5004 31.5503 33.2204 31.5503C26.9404 31.5503 21.8604 26.4603 21.8604 20.1903V16.1803C21.8604 9.90031 26.9504 4.82031 33.2304 4.82031C39.5104 4.82031 44.5904 9.91031 44.5904 16.1803V20.1903Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5998 56.4998V51.3698C50.6698 41.7698 42.9498 33.9298 33.3498 33.8598C23.7498 33.7898 15.9098 41.5098 15.8398 51.1098C15.8398 51.1998 15.8398 51.2898 15.8398 51.3698V56.4998H50.5998Z",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5303 56.5004V51.1504",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9199 56.5004V51.1504",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1301 74.8899C49.1301 75.5599 53.4801 76.1099 58.8501 76.1099C64.2201 76.1099 68.5701 75.5699 68.5701 74.8899C68.5701 74.2199 64.2201 73.6699 58.8501 73.6699C53.4801 73.6699 49.1201 74.2099 49.1201 74.8899H49.1301Z",
    fill: "#E0E9FD"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0499 52.99C74.0499 51.91 73.1699 51.03 72.0899 51.03H64.2499C63.7099 51.03 63.2699 50.59 63.2699 50.05V42.21C63.2699 41.13 62.3899 40.25 61.3099 40.25H56.4099C55.3299 40.25 54.4499 41.13 54.4499 42.21V50.05C54.4499 50.59 54.0099 51.03 53.4699 51.03H45.6299C44.5499 51.03 43.6699 51.91 43.6699 52.99V57.89C43.6699 58.97 44.5499 59.85 45.6299 59.85H53.4699C54.0099 59.85 54.4499 60.29 54.4499 60.83V68.67C54.4499 69.75 55.3299 70.63 56.4099 70.63H61.3099C62.3899 70.63 63.2699 69.75 63.2699 68.67V60.83C63.2699 60.29 63.7099 59.85 64.2499 59.85H72.0899C73.1699 59.85 74.0499 58.97 74.0499 57.89V52.99Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M74.0499 52.99C74.0499 51.91 73.1699 51.03 72.0899 51.03H64.2499C63.7099 51.03 63.2699 50.59 63.2699 50.05V42.21C63.2699 41.13 62.3899 40.25 61.3099 40.25H56.4099C55.3299 40.25 54.4499 41.13 54.4499 42.21V50.05C54.4499 50.59 54.0099 51.03 53.4699 51.03H45.6299C44.5499 51.03 43.6699 51.91 43.6699 52.99V57.89C43.6699 58.97 44.5499 59.85 45.6299 59.85H53.4699C54.0099 59.85 54.4499 60.29 54.4499 60.83V68.67C54.4499 69.75 55.3299 70.63 56.4099 70.63H61.3099C62.3899 70.63 63.2699 69.75 63.2699 68.67V60.83C63.2699 60.29 63.7099 59.85 64.2499 59.85H72.0899C73.1699 59.85 74.0499 58.97 74.0499 57.89V52.99Z",
    fill: "#2B6BF3",
    stroke: "black",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5498 17.3098C28.4498 16.4098 29.9098 16.4098 30.8198 17.3098",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6299 17.4104C36.5299 16.5104 37.9899 16.5104 38.8899 17.4104",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOther);
export default __webpack_public_path__ + "static/media/other.3b590e9c32ecf15e5ea26f4a7f3ba2f8.svg";
export { ForwardRef as ReactComponent };